<p-select
  [options]="options"
  [disabled]="disabled || loading"
  [placeholder]="'Select a State'"
  [showClear]="true"
  [(ngModel)]="selectedCode"
  (onChange)="onSelect($event.value)"
  (onClear)="onClear()"
  [appendTo]="'body'"
></p-select>

@if (loading) {
  <div class="mt-2">Loading states…</div>
}
@if (errorMsg) {
  <div class="mt-2 p-error">{{ errorMsg }}</div>
}

